<template>
  <div class="blog-list-page">
    <Navbar /> <!-- Importa el Navbar igual que en el blog individual -->

    <div class="container py-4">
      <h1 class="page-title">📰 Blog</h1>
      <div class="row">
        <div v-for="blog in blogs" :key="blog.id" class="col-md-4 mb-4">
          <div class="card" @click="$router.push(`/blog/${blog.slug}`)">
            <img :src="blog.imagen_url" alt="Imagen blog" class="card-img-top" />
            <div class="card-body">
              <h5 class="card-title">{{ blog.titulo }}</h5>
              <small class="card-category">{{ blog.categorias }}</small>
              <p class="card-excerpt">{{ stripHtml(blog.contenido).substring(0, 100) }}...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import axios from 'axios';

export default {
  components: { Navbar },
  data() {
    return {
      blogs: []
    };
  },
  methods: {
    stripHtml(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.innerText || div.textContent || "";
    }
  },
  mounted() {
    axios.get('http://localhost:3000/api/blogs')
      .then(res => {
        this.blogs = res.data;
      })
      .catch(err => {
        console.error("Error cargando blogs:", err);
      });
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');

.blog-list-page {
  font-family: 'Open Sans', sans-serif;
  background-color: #fff;
  color: #333;
  min-height: 100vh;
}

.page-title {
  color: #6fa8dc; /* color azul suave */
  font-weight: 700;
  margin-bottom: 1.5rem;
  text-align: center;
}

.card {
  cursor: pointer;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.1);
  transition: box-shadow 0.3s ease;
  background-color: #fafafa;
}

.card:hover {
  box-shadow: 0 8px 20px rgba(0,0,0,0.15);
}

.card-img-top {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  width: 100%;
  height: 180px;
  object-fit: cover;
}

.card-body {
  padding: 1rem 1.2rem;
}

.card-title {
  font-weight: 700;
  font-size: 1.25rem;
  margin-bottom: 0.4rem;
  color: #222;
}

.card-category {
  display: block;
  font-size: 0.9rem;
  color: #557799;
  margin-bottom: 0.8rem;
  font-weight: 600;
}

.card-excerpt {
  font-size: 0.95rem;
  color: #555;
  text-align: justify;
  line-height: 1.4;
}
</style>
